import React, { useState, useEffect } from "react";
import RemotePatientWrapper from "./PatientUi";

export default function PatientEntry() {
  const [sessionCode, setSessionCode] = useState("");
  const [isAdminConnected, setIsAdminConnected] = useState(false);

  useEffect(() => {
    // 1. Generate 9-digit code
    const code = Math.floor(100000000 + Math.random() * 900000000).toString();
    setSessionCode(code);

    // 2. Register code with server
    window.electronAPI?.socketEmit("register-patient-code", code);

    // 3. Listen for admin joining
    window.electronAPI?.socketOn("admin-joined-session", () => {
      setIsAdminConnected(true);
      // Automatically trigger your startScreenShare logic here
    });
  }, []);

  if (isAdminConnected) {
    return <RemotePatientWrapper sessionCode={sessionCode} />; // Your existing video UI
  }

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#111",
        color: "#fff",
      }}
    >
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          background: "#222",
          borderRadius: "20px",
          border: "1px solid #444",
        }}
      >
        <h2 style={{ color: "#888" }}>Your Connection Code</h2>
        <div
          style={{
            fontSize: "48px",
            fontWeight: "bold",
            letterSpacing: "8px",
            margin: "20px 0",
            color: "#22c55e",
          }}
        >
          {sessionCode.match(/.{1,3}/g)?.join("-")}
        </div>
        <p>Share this code with your Support Agent to start the session.</p>
        <div className="loader">Waiting for Admin...</div>
      </div>
    </div>
  );
}
